import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";
import type { ISalesInvoiceReportGetAllParams } from "@api/stores/salesInvoiceReport/types";

import type { IPathBaseParam } from "./path";
import type { IFinancialStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<IFinancialStatsResponse>,
  IPathBaseParam,
  ISalesInvoiceReportGetAllParams
>("stores.financial.stats");

export const stats = {
  ...getApis,
};
